import { Send, MessageSquareText, UserPlus2 } from "lucide-react";

const steps = [
  {
    id: 1,
    icon: Send,
    title: "Submit your order",
    body: "Enter your Roblox username and phone number on the form below. Takes 10 seconds.",
  },
  {
    id: 2,
    icon: MessageSquareText,
    title: "Get a text from us",
    body: "We'll text you our Cash App $cashtag. Cash App is the only payment we accept — no Venmo, Zelle, PayPal or cards.",
  },
  {
    id: 3,
    icon: UserPlus2,
    title: "Hop in & enjoy",
    body: "We add you on Roblox, drop into your world and hand over the full forest bundle.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-24 md:py-32 border-t border-emerald-900/30"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-emerald-300 font-bold">
            How it works
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl mt-3 text-white leading-tight">
            Three steps. <span className="text-amber-400">Five bucks.</span>
          </h2>
        </div>

        <ol className="mt-14 grid md:grid-cols-3 gap-5 relative">
          {steps.map((s, idx) => {
            const Icon = s.icon;
            return (
              <li
                key={s.id}
                data-testid={`step-${s.id}`}
                className="relative p-7 rounded-3xl bg-[#06121C] border border-emerald-950 hover:border-amber-500/40 transition"
              >
                <div className="flex items-center gap-4">
                  <span className="font-serif text-5xl text-amber-400/80 leading-none">
                    0{s.id}
                  </span>
                  <span className="w-px h-10 bg-emerald-900/60" />
                  <Icon className="w-6 h-6 text-emerald-200" />
                </div>
                <h3 className="font-serif text-2xl text-white mt-6">
                  {s.title}
                </h3>
                <p className="mt-3 text-emerald-100/70 leading-relaxed">
                  {s.body}
                </p>
                {idx < steps.length - 1 && (
                  <span className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-emerald-900/60" />
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
